import { render, staticRenderFns } from "./sample-table-form.vue?vue&type=template&id=05f6340a"
import script from "./sample-table-form.vue?vue&type=script&lang=js"
export * from "./sample-table-form.vue?vue&type=script&lang=js"
import style0 from "./sample-table-form.vue?vue&type=style&index=0&id=05f6340a&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports